/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useTranslator } from '@jutro/locale';
import { WMICVariousUtil, WMICTopics } from 'wmic-portals-utils-js';
import { publish } from '@jutro/events';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { withRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withTracking } from '@xengage/gw-portals-tracking-react';
// NEW: Import error tracking for Adobe Analytics (INS document requirement)
import { setError, ERROR_REASONS } from '../../../../../quote-and-buy/src/utils/dataLayer';

import metadata from './WMICKnockoutPage.metadata.json5';
import messages from './WMICKnockoutPage.messages';

function WMICKnockoutPage(props) {
    const { location } = props;
    const translator = useTranslator();
    const quoteNumber = location.state.quoteID;
    const reasons = location.state.underwritingIssues;
    
    // NEW: Track knockout error for Adobe Analytics (INS document page 40-42)
    useEffect(() => {
        // Set error in data layer with INS format: "sorry callustoproceed-quote cannot be edited online"
        setError(ERROR_REASONS.QUOTE_CANNOT_BE_EDITED, 'sorry callustoproceed');
        
        // Track sorry page view for Adobe Analytics
        publish(WMICTopics.ROUTE_CHANGED, {
            page: 'insurance:renters:quote:sorry callustoproceed',
            subchannel2: 'quote',
            ins_quoteid: quoteNumber,
            ins_quote_id: quoteNumber ? 'IQQ' + quoteNumber : ''
        });
        
        // Track error event
        publish(WMICTopics.FORM_ERROR, {
            error: 'underwriting issue',
            error_message: reasons && reasons.length > 0 ? reasons.join(', ') : 'Unable to offer coverage',
            page: 'insurance:renters:quote:sorry callustoproceed',
            ins_quoteid: quoteNumber
        });
        
        // Fire analytics with updated data layer
        if (window.utag && window.utag.view) {
            window.utag.view(window.wins_data_layer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getRecommendationText = () => {
        return (
            <span>
                {translator(messages.weRecommend1)} <a href="tel:1-888-995-3111">{translator(messages.weRecommendPhoneNumber)}</a> {translator(messages.weRecommend2)}
            </span>
        );
    };

    const getRequestText = () => {
        return (
            <span>
                {translator(messages.requestDetails)} <a href="tel:1-877-W Insurance (929-2637)">{translator(messages.requestPhoneNumber)}</a> .
            </span>
        );
    };

    const getQuoteNumber = () => {
        return (
            <span>
                {translator(messages.yourQuoteNumber)} <b>{quoteNumber}</b> .
            </span>
        );
    };

    const getByCallingText = () => {
        return (
            <span>
                {translator(messages.orByCalling)} <a href="tel:1-503-643-5448"> {translator(messages.contactPhone)} </a> .
            </span>
        );
    };

    const getReturnToWawanesaLink = () => {
        return (
            <span>
                <a href="w-insurance.com">{translator(messages.returnToWInsurance)}</a> .
            </span>
        );
    };

    const overrideProps = {
        wmicKnockoutTitle: {
            content: WMICVariousUtil.getTextWithIcon('wmicKOIconColor fa fa-fw fa-exclamation-circle', translator(messages.unableToOffer))
        },
        wmicKnockoutPageTextSectionHeader: {
            content: getRecommendationText()
        },
        knockoutReasonsIterable: {
            data: reasons,
            content: reasons,
            visible: true
        },
        knockoutRequestDetailsText: {
            content: getRequestText()
        },
        quoteNumber: {
            content: getQuoteNumber()
        },
        knockoutEligibilityAddressTextContinued: {
            content: getByCallingText()
        },
        returnToWawanesaLink: {
            content: getReturnToWawanesaLink()
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
        />
    );
}

WMICKnockoutPage.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({
            underwritingIssues: PropTypes.arrayOf(PropTypes.shape({})),
            quoteID: PropTypes.string
        })
    }).isRequired
};

export default withViewModelService(withRouter(withTracking(WMICKnockoutPage)));
